import { render } from "./EditLead.vue?vue&type=template&id=65f15a52"
import script from "./EditLead.vue?vue&type=script&lang=js"
export * from "./EditLead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__